import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params  } from '@angular/router';
import { AuthService} from './service.auth';
import { CommonService} from './service.common';

@Component({
//    selector: 'wrapper-intro'
    template: ''
})
export class WrapperIntroComponent{
    constructor(
        private commonService: CommonService,
        private authService: AuthService,
//        private route: ActivatedRoute,
        private router: Router
    ) {}
    async ngOnInit() {
        if(! await this.authService.isAuthenticated()){
			//this.router.navigate(['/login']);
            document.location.assign('/login');
		}

		// if(localStorage.getItem("accountlogin") == "false"){
        //     document.location.assign('/donation/login');
        //     return;
        // }
		this.commonService.isAuthencatedIp()
		.then((resp) => {
			if(resp){
				localStorage.setItem('showDonation', 't');
			}
            else{
				localStorage.setItem('showDonation', 'f');
            }

		})


		document.location.assign(this.authService.apipath +
            '/site/introduction.html');
    }
}


// WEBPACK FOOTER //
// ./src/app/wrapperIntro.ts